<template lang="pug">
y-dialog(
  fill-height,
  fluid,
  v-model="showModal",
  scrollable,
  transition="fade-transition",
  persistent,
  max-width="600px"
)
  v-card
    v-card-title.h6.basic800--text {{ $t('invited_list') }}
    v-divider.basic300
    v-card-text.pa-0
      v-form(ref="form")
        v-card.elevation-0.border-bottom.pa-3(
          v-if="invitedlist.length < 1",
          style="border-radius: 0px"
        )
          v-row.px-3
            v-col.py-0
              v-img.mx-auto(
                :src="require('@/assets/images/icon_empty.png')",
                style="width: 80px; height: 80px",
                contain
              )
              p.caption.text-center {{ $t('no_invitation_yet') }}
        template(v-else)
          v-card.py-2(
            style="border-radius: 0px",
            v-for="(invited, index) in invitedlist",
            :key="index"
          )
            v-row(no-gutters)
              v-col.px-3
                p.ma-0.s2.textColorDefault--text {{ invited.email || invited.phone }}
              v-col.shrink
                .d-flex.justify-center.align-center
                  v-btn(
                    outlined,
                    small,
                    color="primary500",
                    height="24",
                    @click="sendEmailInvitation(invited.id)",
                    style="background-color: var(--v-basic600T08)"
                  )
                    .button-AA-tiny {{ $t('resend') }}
                  v-menu(left, offset-y)
                    template(v-slot:activator="{ on }")
                      v-btn(text, color="transparent", small, v-on="on")
                        eva-icon(
                          name="more-vertical",
                          :fill="$vuetify.theme.themes[$theme].primary500",
                          height="25",
                          width="25"
                        )
                    v-list.pa-0(dense)
                      v-list-item.border-bottom(
                        @click="deleteInvitation(invited.id)"
                      )
                        v-list-item-content
                          v-list-item-title.s2.basic800--text {{ $t('delete_invitation') }}
            .px-3
              v-menu(right, :offset-x="true")
                template(v-slot:activator="{ on, value }")
                  v-btn.pa-0(
                    text,
                    color="transparent",
                    :ripple="false",
                    small,
                    link,
                    v-on="on",
                    @click="showRoleOption = !showRoleOption"
                  )
                    .p2.textColorHint--text.text-capitalize {{ roles.filter((f) => f.id === invited.role)[0].name }}
                    eva-icon.mr-n1.mt-1(
                      :name="value ? 'chevron-up' : 'chevron-down'",
                      :fill="$vuetify.theme.themes[$theme].textColorHint",
                      height="35"
                    )
                v-list(width="169px")
                  template(v-for="role in roles")
                    v-list-item.my-n2.border-bottom(
                      @click="changeRole(invited.id, role.id)"
                    )
                      v-list-item-title.s2.basic800--text {{ role.name }}
                    v-divider.basic300
            //- tr(v-for="(invited, index) in invitedlist")
              td.px-2
                div.text-center {{ index + 1 }}
              td.px-1
                div.my-2
                  div.hide-overflow.mb-1(:style="$vuetify.breakpoint.smAndDown ? 'width: 180px' : ''")
                    v-icon.mr-2(v-if="invited.email" size="17") mdi-gmail
                    v-icon.mr-2(v-else size="17") mdi-phone
                    | {{ invited.email || invited.phone }}
                  div.font-weight-bold(:class="invited.expired ? 'red--text text--darken-2' : 'orange--text text--darken-2'")
                    v-icon.mr-2(size="17") mdi-account-key
                    v-menu(right :offset-y='true')
                      template(v-slot:activator='{ on }')
                        v-chip.my-auto.px-3(small outlined v-on="on")
                          div {{ roles.filter(f => f.id === invited.role)[0].name }}
                          v-icon.ml-1(right small :class="{'ml-0': $vuetify.breakpoint.xsOnly }") mdi-chevron-down
                      v-list
                        template(v-for="role in roles")
                          v-list-item.my-n2(@click="changeRole(invited.id, role.id)")
                            v-list-item-title {{ role.name }}
              td.px-1
                div.text-center
                  v-btn(icon @click="sendEmailInvitation(invited.id)")
                    v-icon(v-if="invited.email") mdi-email-send
                    v-icon(v-else) mdi-phone-message
              td.px-1
                div.text-center
                  v-btn(icon @click="deleteInvitation(invited.id)")
                    v-icon mdi-delete-outline

    v-card-actions.px-5
      v-spacer
      v-btn(text, @click="showModal = false")
        .button-Aa-small.primary400--text {{ $t('close') }}

    .modals
      y-dialog(v-model="openDeleteDialog", max-width="290", persistent)
        v-card
          v-card-title.h6.basic800--text.px-4 {{ $t('delete_invitation') }}
          v-card-text.p2.primary500--text.px-4 {{ $t('delete_invitation_description') }}
          v-card-actions
            v-spacer
            v-btn(color="white", text, @click="openDeleteDialog = false")
              .button-Aa-small.primary400--text {{ $t('cancel') }}
            v-btn.mr-2(
              color="danger500",
              depressed,
              height=32,
              @click="startDelete"
            )
              .button-AA-small.basic100--text {{ $t('delete') }}
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "InvitedList",
  props: ["open", "company"],
  data: () => ({
    showRoleOption: false,
    inviteRole: null,
    isLoading: false,
    openDeleteDialog: false,
    deletingInvitationId: null,
    invitedlist: [],
    roles: [
      { name: "Admin", id: 1 },
      { name: "Salesperson", id: 2 },
      { name: "Agent", id: 3 },
    ],
  }),
  computed: {
    showModal: {
      get() {
        return this.open;
      },
      set(newValue) {
        this.$emit("update:open", newValue);
      },
    },
    authMember() {
      return this.$store.state.user.member;
    },
  },
  watch: {
    showModal: {
      immediate: true,
      handler(val) {
        if (val) {
          this.fetchInvitedList();
        }
      },
    },
  },
  methods: {
    ...mapActions(["showMessage"]),
    fetchInvitedList() {
      this.$axios
        .get(
          `/invitations/?page_size=-1&company=${this.company.id}&accepted=false&ordering=id`
        )
        .then((resp) => {
          if (resp.data.results.length > 0) {
            this.invitedlist = resp.data.results;
          }
        });
    },
    changeRole(invited_id, role_id) {
      this.$axios
        .patch(
          `/invitations/${invited_id}?company=${this.company.id}&normal_id=true&ordering=id`,
          { role: role_id }
        )
        .then((resp) => {
          if (resp.data.id) {
            this.fetchInvitedList();
          }
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        });
    },
    sendEmailInvitation(id) {
      this.$axios
        .post(`/invitations/${id}/send/?company=${this.company.id}`)
        .then(() => {
          this.showMessage(["success", "Invitation sent"]);
          // this.showModal = false
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.loading = false;
        });
    },
    deleteInvitation(id) {
      this.openDeleteDialog = true;
      this.deletingInvitationId = id;
    },
    startDelete() {
      this.$axios
        .delete(
          `/invitations/${this.deletingInvitationId}/?company=${this.company.id}`
        )
        .then(() => {
          this.showMessage(["success", "Invitation deleted"]);
          this.invitedlist = this.invitedlist.filter(
            (i) => i.id !== this.deletingInvitationId
          );
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.openDeleteDialog = false;
        });
    },
  },
};
</script>

<style scoped>
.hide-overflow {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.border-bottom {
  border-bottom: 1px solid var(--v-basic300);
  border-radius: 0 !important;
}
</style>

<i18n>
{
  "en": {
    "no_invitation_yet": "No invitation yet or empty",
    "delete_invitation": "Delete invitation",
    "delete_invitation_description": "Are you sure you want to delete this invitation? This invitation will be deleted permanently."
  },
  "id": {
     "no_invitation_yet": "Belum ada undangan atau kosong",
    "delete_invitation": "Hapus undangan",
    "delete_invitation_description": "Anda yakin ingin menghapus undangan ini? Undangan ini akan dihapus secara permanen."
  }
}
</i18n>